import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import type { PaginatedResponse, SyncHealth, SyncJob } from "./types";

export function useSyncJobs(params?: Record<string, string>) {
  return useQuery<PaginatedResponse<SyncJob>>({
    queryKey: ["sync", "jobs", params],
    queryFn: async () => {
      const { data } = await client.get("/sync/jobs/", { params });
      return data;
    },
  });
}

export function useTriggerSync() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (integrationSource: string) => {
      const { data } = await client.post("/sync/jobs/trigger/", {
        integration_source: integrationSource,
      });
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["sync"] }),
  });
}

export function useSyncHealth() {
  return useQuery<SyncHealth[]>({
    queryKey: ["sync", "health"],
    queryFn: async () => {
      const { data } = await client.get("/sync/health/");
      return data.data;
    },
  });
}
